(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-custom"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Update cart count if your theme emits events
  document.addEventListener('cart:refresh', (e) => {
    const el = document.querySelector('[data-cart-count]');
    if (el && e.detail?.cart?.item_count != null) el.textContent = e.detail.cart.item_count;
  });

  // Mobile drawer
  const drawer = document.getElementById('pw-drawer');
  const openBtn = document.querySelector('.btn-mobile');
  const closeBtn = drawer?.querySelector('.icon-close-popup');

  const open = () => {
    drawer?.classList.add('is-open');
    drawer?.style.setProperty('display', 'block', 'important');
    drawer?.removeAttribute('hidden');
    drawer?.setAttribute('aria-hidden','false');
    openBtn?.setAttribute('aria-expanded','true');
    document.documentElement.classList.add('pw-lock');
    document.body.classList.add('pw-lock');
  };
  const close = () => {
    drawer?.classList.remove('is-open');
    drawer?.style.setProperty('display', 'none', 'important');
    drawer?.setAttribute('hidden','');
    drawer?.setAttribute('aria-hidden','true');
    openBtn?.setAttribute('aria-expanded','false');
    document.documentElement.classList.remove('pw-lock');
    document.body.classList.remove('pw-lock');
    openBtn?.focus({preventScroll:true});
  };

  openBtn?.addEventListener('click', (e) => { e.preventDefault(); open(); });
  closeBtn?.addEventListener('click', (e) => { e.preventDefault(); close(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Mobile submenu toggles
  drawer?.querySelectorAll('.nav-mb-item').forEach((item) => {
    const toggle = item.querySelector('.mb-sub-toggle');
    const panel = item.querySelector('.sub-nav-menu');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', (!expanded).toString());
      panel.hidden = expanded;
    });
  });

  const handleNavLink = (event) => {
    const link = event.target?.closest?.('.nav-ul-mb a.mb-menu-link, .nav-ul-mb .sub-nav-link');
    if (!link) return;

    const rawHref = link.getAttribute('href') || '';
    let hash = '';

    if (rawHref.startsWith('#')) {
      hash = rawHref;
    } else if (rawHref) {
      try {
        const url = new URL(rawHref, window.location.href);
        if (url.origin === window.location.origin && url.pathname === window.location.pathname) {
          hash = url.hash;
        }
      } catch (error) {
        // Ignore malformed hrefs and just close the drawer.
      }
    }

    close();

    if (hash) {
      event.preventDefault();
      const target = document.querySelector(hash);
      if (target) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', hash);
          });
        });
      }
    }
  };

  drawer?.addEventListener('pointerdown', handleNavLink, true);
  drawer?.addEventListener('click', handleNavLink, true);

  drawer?.addEventListener(
    'touchend',
    (event) => {
      const link = event.target?.closest?.('a');
      if (link) close();
    },
    { passive: true }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["owner-card-section"] && !Shopify.designMode) return;
  try {
    
  // Load Swiper from CDN if the theme doesn't already include it
  (function() {
    function ready(fn){ document.readyState!=='loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
    function ensureSwiper(cb){
      const haveSwiper = window.Swiper && typeof window.Swiper === 'function';
      if (haveSwiper) return cb();
      const css = document.createElement('link'); css.rel='stylesheet'; css.href='https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
      const js = document.createElement('script'); js.src='https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js'; js.defer=true;
      js.onload = cb; document.head.appendChild(css); document.head.appendChild(js);
    }

    ready(function(){
      ensureSwiper(function(){
        document.querySelectorAll('#shopify-section-{{ section.id }} .tf-sw-collection').forEach(function(el){
          const slidesPerView = parseInt(el.dataset.preview) || 2;
          const slidesTablet  = parseInt(el.dataset.tablet) || 2;
          const slidesMobile  = parseInt(el.dataset.mobile) || 1;
          const spaceLg       = parseInt(el.dataset.spaceLg) || 30;
          const spaceMd       = parseInt(el.dataset.spaceMd) || 30;
          const spaceSm       = parseInt(el.dataset.space)   || 15;
          const loop          = el.dataset.loop === 'true';
          const autoPlay      = el.dataset.autoPlay === 'true';
          const speed         = parseInt(el.dataset.speed) || 3000;

          new Swiper(el, {
            slidesPerView: slidesPerView,
            spaceBetween: spaceLg,
            loop: loop,
            autoplay: autoPlay ? { delay: speed, disableOnInteraction: false } : false,
            pagination: {
              el: el.parentElement.querySelector('.swiper-pagination'),
              clickable: true
            },
            navigation: {
              nextEl: el.parentElement.querySelector('.swiper-button-next'),
              prevEl: el.parentElement.querySelector('.swiper-button-prev')
            },
            breakpoints: {
              0:   { slidesPerView: slidesMobile, spaceBetween: spaceSm },
              768: { slidesPerView: slidesTablet, spaceBetween: spaceMd },
              1200:{ slidesPerView: slidesPerView, spaceBetween: spaceLg }
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
